
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","fill":"#5ce8ad"}},[_c('path',{attrs:{"d":"M9 27.4L21.3 37l4.7-5.4L13.7 22z"}}),_c('path',{attrs:{"d":"M33.8 12L16 32.4l5.2 4.6L39 16.6z"}})])])
          )
        }
      }
    